module.exports = __webpack_public_path__ + "static/media/banner1.50a130e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner1.jpg
// module id = 135
// module chunks = 0